angular.module('impactx.purchaseorder').controller('DeliveryOverdueCtrl', [
    '$scope',
    '$mdDialog',
    'deliveryOverdue',
    'themeFactory',
    'sendLabel',
    'abortLabel',
    'headerLabel',
    'pohId',
    'dataGen',
    'requiredLabel',
    DeliveryOverdueCtrl]);

function DeliveryOverdueCtrl($scope, $mdDialog, deliveryOverdue, themeFactory, sendLabel, abortLabel, headerLabel, pohId, dataGen, requiredLabel)
{
    $scope.subject = deliveryOverdue.subject;
    $scope.message = deliveryOverdue.message;
    $scope.mail = deliveryOverdue.mail;
    $scope.theme = themeFactory.getTheme();
    $scope.headerLabel = headerLabel;
    $scope.sendLabel = sendLabel;
    $scope.abortLabel = abortLabel;
    $scope.requiredLabel = requiredLabel;
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.send = function ()
    {
        var dataObj = {
            pohId: pohId,
            deliveryOverdue: deliveryOverdue
        };
        dataGen.postAsForm($scope, dataObj, "/purchaseorder/deliveryoveduereminder").then(function()
        {
            $mdDialog.hide();
        });
    };
}